// eslint-disable-next-line import/no-webpack-loader-syntax
import _INITIAL_PASSAGE_TEXT from "!!raw-loader!./INITIAL_PASSAGE_TEXT.txt";

export const VIEW_NAME_PASSAGE = "passage";
export const VIEW_NAME_WORDS_RUNNER = "words-runner";

export const INITIAL_PASSAGE_TEXT = _INITIAL_PASSAGE_TEXT;
